import { getRequest } from "../api/apiServices";
import apiList from "../api/apiList";
import { isHiringManagerUser } from "../utils/helper";

export type SubscriptionStatus = "ACTIVE" | "EXPIRED";

export interface SubscriptionData {
  type: string;
  status: SubscriptionStatus;
  startDate: string;
  endDate: string;
  isPremium: boolean;
}

export { isHiringManagerUser };

/**
 * Fetches the current subscription and checks if it's active.
 * Hiring managers are not tied to subscriptions — they inherit company access.
 */
export const getCurrentSubscription = async (): Promise<{
  subscription: SubscriptionData | null;
  isActive: boolean;
}> => {
  if (isHiringManagerUser()) {
    return { subscription: null, isActive: true };
  }

  try {
    const response: any = await getRequest(apiList.purchaseSubscriptionStatus);

    if (!response?.data?.success) {
      return { subscription: null, isActive: false };
    }

    const subscription: SubscriptionData | undefined = response?.data?.data;

    if (!subscription) {
      return { subscription: null, isActive: false };
    }

    const isActive = subscription.status === "ACTIVE";

    return { subscription, isActive };
  } catch (error) {
    console.error("Error fetching subscription:", error);
    return { subscription: null, isActive: false };
  }
};
